import { render } from "./datosBasicosDetalle.vue?vue&type=template&id=dc5ec2c0&scoped=true"
import script from "./datosBasicosDetalle.vue?vue&type=script&lang=js"
export * from "./datosBasicosDetalle.vue?vue&type=script&lang=js"

import "./datosBasicosDetalle.vue?vue&type=style&index=0&id=dc5ec2c0&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5ec2c0"]])

export default __exports__